const listadoClientes = [
    "./img/1.png","./img/2.png","./img/3.png","./img/4.png","./img/5.png","./img/5c.png"
];

export default listadoClientes;